import { CustomProvider } from "@/queries/providers/types";
import { FieldType, StepT, StepType } from "../../Stepper/Step/types";
import { mapProviderToDisplayName } from "../../ProviderDropdown/utils";
import { ProviderWithLogo } from "../../ProviderWithLogo";

export const ALLOWED_PROVIDERS = ["openai", "anthropic", "cohere"];

export const getCustomProviderSteps = (
  providers: CustomProvider[],
  isPreview: boolean,
  isEdit: boolean,
) => {
  const title = isEdit
    ? "Edit Custom Provider"
    : isPreview
    ? "Preview Custom Provider"
    : "Create Custom Provider";
  const description = isEdit
    ? "Edit the custom provider to use in your workspace."
    : isPreview
    ? "Preview the custom provider to use in your workspace."
    : "Create a custom provider to use in your workspace.";

  return [
    {
      id: "create_custom_provider",
      title,
      description,
      isOptional: false,
      type: StepType.FIELDS,
      options: [
        {
          readOnly: isPreview,
          label: "Name",
          id: "name",
          tooltip: "This is a human readable name for the provider",
          type: FieldType.TEXT,
          placeholder: "Enter the name of the provider",
        },
        {
          readOnly: isPreview,
          label: "Client",
          id: "client",
          type: FieldType.AUTOCOMPLETE,
          placeholder: "Example: OpenAI",
          addNewOption: false,
          tooltip: "Select the client for your provider base url",
          fieldOptions: providers
            .filter(
              (item) =>
                !item.workspace_id && ALLOWED_PROVIDERS.includes(item.name),
            )
            .map((provider) => ({
              label: mapProviderToDisplayName(provider.name),
              value: provider.name,
              id: provider.name,
            })),
          renderOption: (value) => <ProviderWithLogo provider={value.value} />,
        },
        {
          readOnly: isPreview,
          label: "Base URL",
          id: "base_url",
          type: FieldType.URL,
          placeholder: "Enter the base URL of the provider",
        },
        {
          readOnly: isPreview,
          label: "API Key",
          id: "api_key",
          type: FieldType.TEXT,
          placeholder: "Enter the API key of the provider",
          inputType: "password",
        },
      ],
    },
  ] as StepT[];
};
